import React, { useState, useEffect } from "react";
import useCreadyApi from "../../utils/Api";
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import FortnoxList from "../../pages/FortnoxList";
import { useLocation } from "react-router-dom";
import { Dialog, Transition } from '@headlessui/react'

const IntegrationComponent = () => {
  const api = useCreadyApi();
  const [integration, setIntegration] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [confirmation, setConfirmation] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchIntegration = async () => {
      try {
        const data = await api.integrations.list();
        if (data?.integrations?.length) {
          setIntegration(data.integrations[0]);
        }
      } catch (error) {
        console.error("Failed to fetch integrations:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchIntegration();
  }, []);

  if (isLoading) {
    return (
      <></>
    );
  }

  const handleDisconnect = async () => {
    if (confirmation === "JAG FÖRSTÅR") {
      try {
        await api.integrations.remove();
        setIntegration(null);
        setShowPopup(false);
        setConfirmation("");
      } catch (error) {
        console.error("Failed to remove integration:", error);
      }
    }
  };

  const handleConnect = async () => {
    try {
      const body = 0;
      const response = await api.integrations.create(body);
      if (response?.url) {
        window.location.href = response.url;
      }
    } catch (error) {
      console.error("Failed to create integration:", error);
    }
  };

  
  if (!integration) {
    return (
      <div className="px-8 py-3 max-w-lg mx-auto bg-white rounded-lg shadow-md m-6">
        <h2 className="text-xl font-semibold mb-4">
          Skapa koppling till Fortnox
        </h2>
        <p>Med vår Fortnox-integration hämtar du smidigt upp alla obetalda och förfallna fakturor från Fortnox. Du markerar vilka fakturor som ska skickas in i portalen för inkassohantering.</p>
        <p className="mb-4 mt-2">
          Innan du skapar kopplingen, kontrollera följande i din Fortnox:
        </p>
        <ul>
          <div className="flex items-center mt-6"><CheckCircleIcon stroke="green" className="h-6 w-6 mr-2" aria-hidden="true"/>
          <li>Integrationslicensen är aktiverad</li></div>
          <div className="flex items-center mt-2 mb-8"><CheckCircleIcon stroke="green" className="h-6 w-6 mr-2" aria-hidden="true"/>
            <li>Du har rollen "Systemadministratör"</li></div>
        </ul>
        <button
          className="mt-6 block px-6 py-2.5 mb-4 text-m font-semibold text-center hover:text-blue-1 bg-blue-1 align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-blue-1 border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
          onClick={handleConnect}
        >
          Skapa koppling
        </button>
      </div>
    );
  }

  const externalData = JSON.parse(integration.externalData);
  
  if (location.state?.showSettings) {
    return (
      <div className="px-6 pb-4 pt-5  max-w-md mx-auto rounded-lg shadow-md">
   

      <img className="h-16 pb-4 mb-4" src="fortnox-logo.svg" alt="cready" />
      <p className="text-gray-900">Koplingen med Fortnox är {integration.integrationStatus == 2 ? "aktiv" : "inaktiv"}.</p>
      <p className="text-gray-900">Hantera integrationen nedan.</p>
      <div className="bg-gray-50 my-6 p-4 pb-6 rounded-lg">
        <h2 className="text-ml mb-1 font-semibold">Integrationskonto</h2>
        <p className="">Företag: {externalData.CompanyName}</p>
        <p className="">
          Organisationnummer: {externalData.OrganizationNumber}
        </p>
      </div>
      {integration.integrationStatus === 2 ? (
        <>
          <div className="flex">
            <button
              className="inline-flex group mt-1 flex items-centers pl-2 pr-4 py-2.5 mb-4 text-m font-semibold text-center text-red hover:bg-red align-middle transition-all duration-100 ease-in-out bg-transparent border-2 border-red border-solid rounded-md cursor-pointer hover:text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
              onClick={() => setShowPopup(true)}
            >
              <XCircleIcon className="stroke-red h-6 w-6 mr-2 group-hover:stroke-white" aria-hidden="true"></XCircleIcon> Ta bort integrationen
            </button>
            <div className="ml-auto">
              <a href="/fortnox">
                <button className="inline-flex mt-1 block px-6 py-2.5 mb-4 text-m font-semibold text-center hover:text-blue-2 bg-blue-2 align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-blue-2 border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1">
                Tillbaka
                </button>
              </a>
            </div>
          </div>
          
        </>
      ) : (
        <button
          className="mt-4 bg-green text-white py-2 px-4 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50"
          onClick={handleConnect}
        >
          Skapa koppling
        </button>
      )}

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full px-4 pb-4 pt-4 ">
            <h3 className="text-lg font-semibold mb-4 mt-3">
              Ta bort integrationen till Fortnox
            </h3>
            <p className="text-gray-900 mb-4">
              OBS! Om du tar bort kopplingen kommer all data i integrationen att försvinna och det går inte att återskapa i efterhand.<br/>
              Vi rekommenderar att du kontaktar oss innan du tar bort integrationen. Om du trots allt vill ta bort kopplingen, skriv <strong>"JAG FÖRSTÅR"</strong> i rutan nedan för att ta bort integrationen
            </p>
            <input
              type="text"
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
              className="border p-2 rounded-lg w-full mb-1"
              placeholder="JAG FÖRSTÅR"
            />
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
             <button
                className="inline-flex mt-1 justify-center pl-2 pr-4 py-2.5 mb-4 text-m font-semibold text-center hover:text-red bg-red align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-red border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
                onClick={handleDisconnect}
              >
                Ja, ta bort
              </button>
              <button
                className="inline-flex mt-1 block px-6 py-2.5 mb-4 text-m font-semibold text-center text-blue-2 hover:bg-blue-2 align-middle transition-all duration-100 ease-in-out bg-transparent border-2 border-blue-2 border-solid rounded-md cursor-pointer hover:text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
                onClick={() => setShowPopup(false)}
              >
                Nej, gå tillbaka
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    );
  }

  return (
     <FortnoxList /> 
  );
};

export default IntegrationComponent;
